import type { ReactNode } from 'react'
import { CustomerAreaHeaderSection } from './CustomerAreaHeaderSection'
import { CustomerAreaNavigation } from './CustomerAreaNavigation'
import { CustomerAreaPageLayout } from './CustomerAreaPageLayout'
import type {
  CustomerAreaHeaderAction,
  CustomerAreaHeaderStat,
  CustomerAreaNavItem,
} from './customerAreaLayoutTypes'

export type { CustomerAreaHeaderAction, CustomerAreaHeaderStat, CustomerAreaNavItem } from './customerAreaLayoutTypes'

type CustomerAreaLayoutShellProps = {
  eyebrow: string
  title: string
  subtitle?: string
  meta?: ReactNode
  headerContent?: ReactNode
  titleClassName?: string
  subtitleClassName?: string
  headerClassName?: string
  mainClassName?: string
  navItems: CustomerAreaNavItem[]
  activeNavId: string
  onNavigate: (targetPath: string) => void
  actions?: CustomerAreaHeaderAction[]
  stats?: CustomerAreaHeaderStat[]
  children: ReactNode
}

export const CustomerAreaLayoutShell = ({
  eyebrow,
  title,
  subtitle,
  meta,
  headerContent,
  titleClassName,
  subtitleClassName,
  headerClassName,
  mainClassName,
  navItems,
  activeNavId,
  onNavigate,
  actions,
  stats,
  children,
}: CustomerAreaLayoutShellProps) => (
  <CustomerAreaPageLayout containerClassName="space-y-4">
    <CustomerAreaHeaderSection
      eyebrow={eyebrow}
      title={title}
      subtitle={subtitle}
      meta={meta}
      headerContent={headerContent}
      titleClassName={titleClassName}
      subtitleClassName={subtitleClassName}
      headerClassName={headerClassName}
      actions={actions}
      stats={stats}
    />

    <CustomerAreaNavigation
      navItems={navItems}
      activeNavId={activeNavId}
      onNavigate={onNavigate}
      mainClassName={mainClassName}
    >
      {children}
    </CustomerAreaNavigation>
  </CustomerAreaPageLayout>
)
